module.exports = __webpack_public_path__ + "img/ttshop_all.2c54f68b.svg";